import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import * as appConstants from 'redux/constants/app.constants';
import * as constants from 'redux/constants/product.constants';
import * as cartConstants from 'redux/constants/cart.constants';
import {
  getAll, getMaxPrice, getMostSelled, getNewArrivals, getOffers, getSearch, getSingle, getProductsHome, getMostSelledHome
} from 'services/product.services';

export function* productGetAll() {
  try {
    const data = yield call(getAll);
    yield put({ type: constants.PRODUCT_GET_ALL_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PRODUCT_GET_ALL_FAILED, error });
  }
}

export function* productGetMaxPrice(data = null) {
  try {
    const isReduxAction = data && data.type;
    const maxPrice = !isReduxAction && data ? data : yield call(getMaxPrice);
    yield put({ type: constants.PRODUCT_GET_MAX_PRICE_SUCCEEDED, data:  maxPrice});
  } catch (error) {
    yield put({ type: constants.PRODUCT_GET_MAX_PRICE_FAILED, error });
  }
}

export function* productGetMostSelled(data = null) {
  try {
    const isReduxAction = data && data.type;
    const mostSelled = !isReduxAction && data ? data : yield call(getMostSelled);
    yield put({ type: constants.PRODUCT_GET_MOST_SELLED_SUCCEEDED, data: mostSelled });
  } catch (error) {
    yield put({ type: constants.PRODUCT_GET_MOST_SELLED_FAILED, error });
  }
}

export function* productGetNewArrivals(data = null) {
  try {
    const isReduxAction = data && data.type;
    const newArrivals = !isReduxAction && data ? data : yield call(getNewArrivals);
    yield put({ type: constants.PRODUCT_GET_NEW_ARRIVALS_SUCCEEDED, data: newArrivals });
  } catch (error) {
    yield put({ type: constants.PRODUCT_GET_NEW_ARRIVALS_FAILED, error });
  }
}

export function* productGetOffers(data = null) {
  try {
    const isReduxAction = data && data.type;
    const offers = !isReduxAction && data ? data : yield call(getOffers);
    yield put({ type: constants.PRODUCT_GET_OFFERS_SUCCEEDED, data: offers });
  } catch (error) {
    yield put({ type: constants.PRODUCT_GET_OFFERS_FAILED, error });
  }
}

export function* productGetSearch(action) {
  try {
    if (action.value.trim().length >= 3) {
      const data = yield call(getSearch, action.value);
      yield put({ type: constants.PRODUCT_GET_SEARCH_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.PRODUCT_GET_SEARCH_FAILED, error });
  }
}

export function* productGetSingle(action) {
  try {
    if (action.value) {
      const data = yield call(getSingle, action.value);
      yield put({ type: constants.PRODUCT_GET_SINGLE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.PRODUCT_GET_SINGLE_FAILED, error });
  }
}

export function* watchProducts() {
  yield all([
    // takeLatest(appConstants.APP_INITIALIZE_REQUESTED, productGetMaxPrice),
    takeLatest(
      [
        appConstants.APP_INITIALIZE_REQUESTED,
        cartConstants.CART_CHECKOUT_SUCCEEDED,
      ],
      productGetAll,
    ),
    takeLatest(
      [
        // appConstants.APP_INITIALIZE_REQUESTED,
        // cartConstants.CART_CHECKOUT_SUCCEEDED,
      ],
      productGetMostSelled,
    ),
    takeLatest(
      [
        // appConstants.APP_INITIALIZE_REQUESTED,
        // cartConstants.CART_CHECKOUT_SUCCEEDED,
      ],
      productGetNewArrivals,
    ),
    takeLatest(
      [
        // appConstants.APP_INITIALIZE_REQUESTED,
        // cartConstants.CART_CHECKOUT_SUCCEEDED,
      ],
      productGetOffers,
    ),
    takeLatest(constants.PRODUCT_GET_SEARCH_REQUESTED, productGetSearch),
    takeLatest(constants.PRODUCT_GET_SINGLE_REQUESTED, productGetSingle),
  ]);
}
